(function () {
  const SEL_ROOT = '[data-wf-pdp-media-gallery]';
  const SEL_SWIPER = '.wf-pdp-media-gallery__swiper';

  /**
   * @param {HTMLElement} root
   */
  function destroySwiper(root) {
    const el = root.querySelector(SEL_SWIPER);
    if (!el) return;
    const prev = el._wfPdpMediaSwiper;
    if (prev && typeof prev.destroy === 'function') {
      try {
        prev.destroy(true, true);
      } catch (_) {}
      el._wfPdpMediaSwiper = null;
    }
  }

  /**
   * @param {HTMLElement} root
   * @returns {import('swiper').Swiper | null}
   */
  function getSwiper(root) {
    const el = root.querySelector(SEL_SWIPER);
    return el && el._wfPdpMediaSwiper ? el._wfPdpMediaSwiper : null;
  }

  /**
   * @param {HTMLElement} root
   */
  function initPdpMediaGallery(root) {
    if (!root || !root.querySelector) return;

    const swiperEl = root.querySelector(SEL_SWIPER);
    if (!swiperEl || typeof window.Swiper !== 'function') return;

    destroySwiper(root);

    const slides = swiperEl.querySelectorAll('.swiper-slide');
    const count = slides.length;
    if (count === 0) return;

    const prevEl = root.querySelector('[data-wf-pdp-prev]');
    const nextEl = root.querySelector('[data-wf-pdp-next]');
    const progressEl = root.querySelector('.wf-pdp-media-gallery__progress');
    const nav = root.querySelector('.wf-pdp-media-gallery__nav');

    if (count <= 1) {
      if (nav) nav.hidden = true;
      if (progressEl) progressEl.hidden = true;
      return;
    }

    if (nav) nav.hidden = false;
    if (progressEl) progressEl.hidden = false;

    const opts = {
      slidesPerView: 1,
      spaceBetween: 0,
      autoHeight: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
    };

    if (prevEl && nextEl) {
      opts.navigation = { prevEl, nextEl };
    }

    if (progressEl) {
      opts.pagination = {
        el: progressEl,
        type: 'progressbar',
      };
    }

    const swiper = new window.Swiper(swiperEl, opts);
    swiperEl._wfPdpMediaSwiper = swiper;

    const updateHeight = () => {
      try {
        swiper.update();
      } catch (_) {}
    };

    swiperEl.querySelectorAll('img').forEach((img) => {
      if (img.complete) return;
      img.addEventListener('load', updateHeight, { once: true });
    });
  }

  /**
   * @param {HTMLElement} mediaGallery
   */
  function initFromMediaGallery(mediaGallery) {
    if (!mediaGallery || mediaGallery.dataset.presentation !== 'wf_swiper') return;
    const root = mediaGallery.querySelector(SEL_ROOT);
    if (root) initPdpMediaGallery(root);
  }

  /**
   * @param {HTMLElement} mediaGallery
   * @param {number} index
   */
  function goToSlide(mediaGallery, index) {
    if (!mediaGallery) return;
    const root = mediaGallery.querySelector(SEL_ROOT);
    if (!root) return;
    const swiper = getSwiper(root);
    if (swiper && typeof swiper.slideTo === 'function') {
      swiper.slideTo(index, 0);
    }
  }

  /**
   * @param {HTMLElement} mediaGallery
   */
  function destroyFromMediaGallery(mediaGallery) {
    if (!mediaGallery) return;
    const root = mediaGallery.querySelector(SEL_ROOT);
    if (root) destroySwiper(root);
  }

  window.wfInitPdpMediaGallery = initFromMediaGallery;
  window.wfPdpMediaGalleryGoTo = goToSlide;
  window.wfDestroyPdpMediaGallery = destroyFromMediaGallery;

  function initAll() {
    document.querySelectorAll('media-gallery[data-presentation="wf_swiper"]').forEach(initFromMediaGallery);
  }

  if (!window.__wfPdpMediaGalleryListeners) {
    window.__wfPdpMediaGalleryListeners = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (!event.target || !event.target.querySelectorAll) return;
      event.target.querySelectorAll('media-gallery[data-presentation="wf_swiper"]').forEach(initFromMediaGallery);
    });
  } else {
    initAll();
  }
})();
